import {Link} from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { IMAGES } from '../layout/theme';

const CheckIcon = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" className="about-check-icon">
        <circle cx="10" cy="10" r="10" fill="#d89d37"/>
        <path d="M6 10.5L8.5 13L14 7" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);

const stats = [
    { value: '1680+', label: 'Guests Hosted' },
    { value: '24/7', label: 'Support' },
    { value: '5★',   label: 'Rated' },
];

const AboutBlog = () => {
    const { t } = useTranslation();
    return (
        <div className="container" id="about-us">
            <div className="about-card">
                {/* Left — image */}
                <div className="about-card-img">
                    <img src={IMAGES.doorSecure} alt="Property managed by Pure Key Homes" />
                </div>

                {/* Right — content */}
                <div className="about-card-content">
                    <span className="sub-title">{t('aboutBlog.subtitle')}</span>
                    <h2 className="h2-title about-h2">{t('aboutBlog.title')}</h2>
                    <p className="about-desc">{t('aboutBlog.description')}</p>

                    <ul className="about-list">
                        <li><CheckIcon />{t('aboutBlog.reservationManagement')}</li>
                        <li><CheckIcon />{t('aboutBlog.keyHolding247')}</li>
                        <li><CheckIcon />{t('aboutBlog.cleaningService')}</li>
                        <li><CheckIcon />{t('aboutBlog.laundryService')}</li>
                        <li><CheckIcon />{t('aboutBlog.propertyCheckAlarm')}</li>
                    </ul>

                    <div className="about-stats">
                        {stats.map((s) => (
                            <div className="about-stat" key={s.label}>
                                <span className="about-stat-value">{s.value}</span>
                                <span className="about-stat-label">{s.label}</span>
                            </div>
                        ))}
                    </div>

                    <Link to="/about-us" className="sec-btn about-cta"><span>{t('aboutBlog.readMore')}</span></Link>
                </div>
            </div>
        </div>
    );
};

export default AboutBlog;